/**
 * Returns an array of page numbers to display in pagination.
 * Shows first page, last page, and a window around the current page with ellipsis.
 * Example: [1, '...', 4, 5, 6, '...', 21]
 */
export const getPageNumbers = (currentPage, totalPages, siblingCount = 1) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = [];
  const leftSibling = Math.max(currentPage - siblingCount, 1);
  const rightSibling = Math.min(currentPage + siblingCount, totalPages);

  const showLeftEllipsis = leftSibling > 3;
  const showRightEllipsis = rightSibling < totalPages - 2;

  // Always show first page
  pages.push(1);

  if (showLeftEllipsis) {
    pages.push("...");
  } else {
    // Show pages 2 up to leftSibling - 1
    for (let i = 2; i < leftSibling; i++) {
      pages.push(i);
    }
  }

  // Show sibling range
  for (let i = leftSibling; i <= rightSibling; i++) {
    if (i !== 1 && i !== totalPages) {
      pages.push(i);
    }
  }

  if (showRightEllipsis) {
    pages.push("...");
  } else {
    for (let i = rightSibling + 1; i < totalPages; i++) {
      pages.push(i);
    }
  }

  // Always show last page
  pages.push(totalPages);

  return pages;
};
